export var TripStatusCode;
(function (TripStatusCode) {
    TripStatusCode["YET_TO_START"] = "YET_TO_START";
    TripStatusCode["IN_PROGRESS"] = "IN_PROGRESS";
    TripStatusCode["COMPLETED"] = "COMPLETED";
    TripStatusCode["CANCELLED"] = "CANCELLED";
})(TripStatusCode || (TripStatusCode = {}));
